import React, { useState, useEffect, useContext, useRef } from "react";
import "../../../constants/report.css";
import axios from "axios";
import { formatDate } from "../../../constants/helper";
import { AuthContext } from "../../../contexts/AuthContext";
import { tempUrl, useStateContext } from "../../../contexts/ContextProvider";
import { Loader } from "../../../components";
import {
  Box,
  ButtonGroup,
  Button,
  Autocomplete,
  TextField,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
} from "@mui/material";
import { Container, Form, Row, Col, Table } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import jsPDF from "jspdf";
import { useDownloadExcel } from "react-export-table-to-excel";
import SearchIcon from "@mui/icons-material/Search";
import PrintIcon from "@mui/icons-material/Print";
import { useReactToPrint } from "react-to-print";
import useScreenWidth from "../../../hooks/useScreenWidth";

const LaporanPinjamanJatuhTempoFidusia = () => {
  const screenSize = useScreenWidth();
  const tableRef = useRef(null);
  const { user, dispatch, setting } = useContext(AuthContext);
  const reportTemplateRef = useRef(null);
  let nowDate = new Date();
  const [perTanggal, setPerTanggal] = useState(new Date());
  const [lebihDari, setLebihDari] = useState("");
  const [sampaiDengan, setSampaiDengan] = useState("");
  const [kodeCabang, setKodeCabang] = useState("");
  const [namaCabang, setNamaCabang] = useState("");
  const [kasirId, setKasirId] = useState("");
  const [namaKasir, setNamaKasir] = useState("");
  const [marketingId, setMarketingId] = useState("");
  const [namaMarketing, setNamaMarketing] = useState("");
  const [surveyorId, setSurveyorId] = useState("");
  const [namaSurveyor, setNamaSurveyor] = useState("");
  const [kategori, setKategori] = useState("");

  const [cabangs, setCabangs] = useState([]);
  const [marketings, setMarketings] = useState([]);
  const [surveyors, setSurveyors] = useState([]);
  const [kasirs, setKasirs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [persenLoading, setPersenLoading] = useState("0");
  const [lapPinjamanJatuhTempoData, setLapPinjamanJatuhTempoData] = useState(
    []
  );
  const [previewPdf, setPreviewPdf] = useState(false);
  const [isCetakExcel, setIsCetakExcel] = useState(false);
  const [error, setError] = useState(false);

  const [filter, setFilter] = useState("SEMUA");

  const handleChangeFilter = (event) => {
    setFilter(event.target.value);
    setPreviewPdf(false);
  };

  const kategoriOption = ["KENDARAAN RODA 2", "KENDARAAN RODA 4"];
  let marketingOptions = marketings.map((marketing) => ({
    label: `${marketing.kodeMarketing} - ${marketing.namaMarketing}`,
    id: marketing.id,
  }));
  let surveyorOptions = surveyors.map((surveyor) => ({
    label: `${surveyor.kodeSurveyor} - ${surveyor.namaSurveyor}`,
    id: surveyor.id,
  }));
  let cabangOptions = cabangs.map((cabang) => ({
    label: `${cabang.id} - ${cabang.namaCabang}`,
    id: `${cabang.id} - ${cabang.namaCabang}`,
  }));
  let kasirOptions = kasirs.map((kasir) => ({
    label: kasir.username,
    id: kasir.id,
  }));

  const generatePDF = useReactToPrint({
    content: () => reportTemplateRef.current,
    documentTitle: "LaporanPinjamanJatuhTempo",
  });

  const tampilPdf = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const form = e.currentTarget;
    if (form.checkValidity()) {
      setLoading(true);
      let tempPersenLoading = parseInt(persenLoading);

      setTimeout(() => {
        tempPersenLoading += 40;
        setPersenLoading(tempPersenLoading.toString());
      }, "1000");

      if (filter === "SEMUA") {
        let pinjamanJatuhTempos = await axios.post(
          `${tempUrl}/laporanPinjamanJatuhTempoFidusia`,
          {
            perTanggal,
            lebihDari,
            sampaiDengan,
            kodeCabang,
            marketingId,
            surveyorId,
            kasirId,
            kategori,
            _id: user.id,
            token: user.token,
          }
        );
        setLapPinjamanJatuhTempoData(pinjamanJatuhTempos.data);
        setPreviewPdf(!previewPdf);
        setLoading(false);
        setTimeout(() => {
          tempPersenLoading = 0;
          setPersenLoading(tempPersenLoading.toString());
        }, "2000");
      } else {
        let pinjamanJatuhTempos = await axios.post(
          `${tempUrl}/laporanPinjamanJatuhTempoTanpaTarik`,
          {
            perTanggal,
            lebihDari,
            sampaiDengan,
            kodeCabang,
            marketingId,
            surveyorId,
            kasirId,
            kategori,
            _id: user.id,
            token: user.token,
          }
        );
        setLapPinjamanJatuhTempoData(pinjamanJatuhTempos.data);
        setPreviewPdf(!previewPdf);
        setLoading(false);
        setTimeout(() => {
          tempPersenLoading = 0;
          setPersenLoading(tempPersenLoading.toString());
        }, "2000");
      }
    }
  };

  useEffect(() => {
    getCabangsData();
    getKasirsData();
    getMarketingsData();
    getSurveyorsData();
    if (user.tipeUser !== "OWNER/DIREKSI") {
      setKodeCabang(user.cabang.id);
      setNamaCabang(`${user.cabang.id} - ${user.cabang.namaCabang}`);
    }
  }, []);

  const getSurveyorsData = async () => {
    const response = await axios.post(`${tempUrl}/surveyors`, {
      _id: user.id,
      token: user.token,
      kodeCabang: user.cabang.id,
    });
    setSurveyors(response.data);
  };

  const getMarketingsData = async () => {
    const response = await axios.post(`${tempUrl}/marketings`, {
      _id: user.id,
      token: user.token,
      kodeCabang: user.cabang.id,
    });
    setMarketings(response.data);
  };

  const getKasirsData = async () => {
    const response = await axios.post(`${tempUrl}/usersRebuild`, {
      _id: user.id,
      token: user.token,
      kodeCabang: user.cabang.id,
    });
    setKasirs(response.data);
  };

  const getCabangsData = async () => {
    const response = await axios.post(`${tempUrl}/cabangs`, {
      _id: user.id,
      token: user.token,
      kodeCabang: user.cabang.id,
    });
    setCabangs(response.data);
  };

  const tableText = {
    letterSpacing: "0.01px",
  };

  const textNumberRight = {
    textAlign: "right",
  };

  const textNumberRightBorder = {
    textAlign: "right",
    border: "1px solid black",
    border: "1px solid black",
  };

  const tableDataBorder = {
    border: "1px solid black",
    border: "1px solid black",
  };

  const list = [];
  let tempTotalModal = 0;
  let tempTotalBunga = 0;
  let tempTotal = 0;

  for (let j = 0; j < lapPinjamanJatuhTempoData.length; j++) {
    tempTotalModal += lapPinjamanJatuhTempoData[j].angModal;
    tempTotalBunga += lapPinjamanJatuhTempoData[j].angBunga;
    tempTotal += lapPinjamanJatuhTempoData[j].angPerBulan;

    let tempTglJtTempo = new Date(lapPinjamanJatuhTempoData[j].tglJtTempo);

    list.push(
      <tr style={tableText}>
        <td style={{ paddingLeft: "15px", border: "1px solid black" }}>
          {j + 1}
        </td>
        <td style={tableDataBorder}>
          <p>{lapPinjamanJatuhTempoData[j].customer.namaCustomer}</p>
          <p>{lapPinjamanJatuhTempoData[j].noPerjanjian}</p>
        </td>
        <td style={tableDataBorder}>
          {lapPinjamanJatuhTempoData[j].customer.alamatCustomer}
        </td>
        <td style={tableDataBorder}>
          {lapPinjamanJatuhTempoData[j].customer.noTeleponCustomer}
        </td>
        <td style={tableDataBorder}>
          {lapPinjamanJatuhTempoData[j].tglJtTempo}
        </td>
        <td style={tableDataBorder}>{tempTglJtTempo.getDate()}</td>
        <td style={textNumberRightBorder}>
          {isCetakExcel === false
            ? lapPinjamanJatuhTempoData[j].pinjamanAju.toLocaleString("en-EN")
            : lapPinjamanJatuhTempoData[j].pinjamanAju}
        </td>
        <td style={textNumberRightBorder}>
          {isCetakExcel === false
            ? lapPinjamanJatuhTempoData[j].tenor.toLocaleString("en-EN")
            : lapPinjamanJatuhTempoData[j].tenor}
        </td>
        <td style={textNumberRightBorder}>
          {isCetakExcel === false
            ? parseInt(lapPinjamanJatuhTempoData[j].hr / 30).toLocaleString(
                "en-EN"
              )
            : parseInt(lapPinjamanJatuhTempoData[j].hr / 30)}
        </td>
        <td style={textNumberRightBorder}>
          {isCetakExcel === false
            ? lapPinjamanJatuhTempoData[j].hr.toLocaleString("en-EN")
            : lapPinjamanJatuhTempoData[j].hr}
        </td>
        <td style={textNumberRightBorder}>
          {isCetakExcel === false
            ? (
                lapPinjamanJatuhTempoData[j].tenor -
                lapPinjamanJatuhTempoData[j].sisaBulan +
                1
              ).toLocaleString("en-EN")
            : lapPinjamanJatuhTempoData[j].tenor -
              lapPinjamanJatuhTempoData[j].sisaBulan +
              1}
        </td>
        <td style={textNumberRightBorder}>
          {isCetakExcel === false
            ? lapPinjamanJatuhTempoData[j].angPerBulan.toLocaleString("en-EN")
            : lapPinjamanJatuhTempoData[j].angPerBulan}
        </td>
        <td style={tableDataBorder}>-</td>
        <td style={tableDataBorder}>
          <ul>
            <li>
              <b>{lapPinjamanJatuhTempoData[j].tipe.namaTipe}</b>
              <b>{lapPinjamanJatuhTempoData[j].tipe.kodeTipe}</b>
              <p>
                No.Pol <b>{lapPinjamanJatuhTempoData[j].nopol}</b>
              </p>
            </li>
          </ul>
        </td>
        <td
          style={tableDataBorder}
        >{`${lapPinjamanJatuhTempoData[j].marketing.kodeMarketing} - ${lapPinjamanJatuhTempoData[j].marketing.namaMarketing}`}</td>
        <td
          style={tableDataBorder}
        >{`${lapPinjamanJatuhTempoData[j].surveyor.kodeSurveyor} - ${lapPinjamanJatuhTempoData[j].surveyor.namaSurveyor}`}</td>
      </tr>
    );
  }

  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: "LaporanPinjamanJatuhTempo",
    sheet: "LaporanPinjamanJatuhTempo",
  });

  const textRight = {
    textAlign: screenSize >= 650 && "right",
  };

  if (loading) {
    return <Loader persenLoading={persenLoading} />;
  }

  return (
    <Container>
      <h3>Laporan</h3>
      <h5 style={{ fontWeight: 400 }}>Laporan Pinjaman Jatuh Tempo</h5>
      <hr />
      <Box sx={spacingTop}>
        <Form onSubmit={tampilPdf}>
          <Row>
            <FormControl sx={{ marginTop: 1 }}>
              <FormLabel id="demo-controlled-radio-buttons-group">
                Filter
              </FormLabel>
              <RadioGroup
                row
                aria-labelledby="demo-controlled-radio-buttons-group"
                name="controlled-radio-buttons-group"
                defaultValue="SEMUA"
                value={filter}
                onChange={handleChangeFilter}
              >
                <FormControlLabel
                  value="SEMUA"
                  control={<Radio />}
                  label="Semua"
                />
                <FormControlLabel
                  value="DI LUAR TARIKAN"
                  control={<Radio />}
                  label="Di luar Tarikan"
                />
              </RadioGroup>
            </FormControl>
          </Row>
          <Row>
            <Col sm={6}>
              <Form.Group
                as={Row}
                className="mb-3"
                controlId="formPlaintextPassword"
              >
                <Form.Label column sm="4" style={textRight}>
                  Per Tanggal :
                </Form.Label>
                <Col sm="8">
                  <DatePicker
                    required
                    dateFormat="dd/MM/yyyy"
                    selected={perTanggal}
                    customInput={<Form.Control required />}
                    onChange={(date) => {
                      setPerTanggal(date);
                      setPreviewPdf(false);
                    }}
                  />
                </Col>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <Form.Group
                as={Row}
                className="mb-3"
                controlId="formPlaintextPassword"
              >
                <Form.Label column sm="4" style={textRight}>
                  Cabang :
                </Form.Label>
                <Col sm="8">
                  {user.tipeUser === "OWNER/DIREKSI" ? (
                    <Autocomplete
                      size="small"
                      disablePortal
                      id="combo-box-demo"
                      options={cabangOptions}
                      renderInput={(params) => (
                        <TextField
                          error={error && kodeCabang.length === 0 && true}
                          size="small"
                          placeholder="SEMUA CABANG"
                          {...params}
                        />
                      )}
                      onChange={(e, value) => {
                        if (value) {
                          setKodeCabang(value.id.split(" ", 1)[0]);
                          setNamaCabang(value.id);
                        } else {
                          setKodeCabang("");
                          setNamaCabang("");
                        }
                        setPreviewPdf(false);
                      }}
                      defaultValue={kodeCabang}
                    />
                  ) : (
                    <Form.Control value={kodeCabang} disabled readOnly />
                  )}
                </Col>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <Form.Group
                as={Row}
                className="mb-3"
                controlId="formPlaintextPassword"
              >
                <Form.Label column sm="4" style={textRight}>
                  Marketing :
                </Form.Label>
                <Col sm="8">
                  <Autocomplete
                    size="small"
                    disablePortal
                    id="combo-box-demo"
                    options={marketingOptions}
                    renderInput={(params) => (
                      <TextField
                        error={error && marketingId.length === 0 && true}
                        size="small"
                        placeholder="SEMUA MARKETING"
                        {...params}
                      />
                    )}
                    onChange={(e, value) => {
                      if (value) {
                        setMarketingId(value.id);
                        setNamaMarketing(value.label);
                      } else {
                        setMarketingId("");
                        setNamaMarketing("");
                      }
                      setPreviewPdf(false);
                    }}
                    defaultValue={marketingId}
                  />
                </Col>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <Form.Group
                as={Row}
                className="mb-3"
                controlId="formPlaintextPassword"
              >
                <Form.Label column sm="4" style={textRight}>
                  Surveyor :
                </Form.Label>
                <Col sm="8">
                  <Autocomplete
                    size="small"
                    disablePortal
                    id="combo-box-demo"
                    options={surveyorOptions}
                    renderInput={(params) => (
                      <TextField
                        error={error && surveyorId.length === 0 && true}
                        size="small"
                        placeholder="SEMUA SURVEYOR"
                        {...params}
                      />
                    )}
                    onChange={(e, value) => {
                      if (value) {
                        setSurveyorId(value.id);
                        setNamaSurveyor(value.label);
                      } else {
                        setSurveyorId("");
                        setNamaSurveyor("");
                      }
                      setPreviewPdf(false);
                    }}
                    defaultValue={namaSurveyor}
                  />
                </Col>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <Form.Group
                as={Row}
                className="mb-3"
                controlId="formPlaintextPassword"
              >
                <Form.Label column sm="4" style={textRight}>
                  Kasir :
                </Form.Label>
                <Col sm="8">
                  <Autocomplete
                    size="small"
                    disablePortal
                    id="combo-box-demo"
                    options={kasirOptions}
                    renderInput={(params) => (
                      <TextField
                        error={error && kasirId.length === 0 && true}
                        size="small"
                        placeholder="SEMUA KASIR"
                        {...params}
                      />
                    )}
                    onChange={(e, value) => {
                      if (value) {
                        setKasirId(value.id);
                        setNamaKasir(value.label);
                      } else {
                        setKasirId("");
                      }
                      setPreviewPdf(false);
                    }}
                    defaultValue={kasirId}
                  />
                </Col>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <Form.Group
                as={Row}
                className="mb-3"
                controlId="formPlaintextPassword"
              >
                <Form.Label column sm="4" style={textRight}>
                  Kategori :
                </Form.Label>
                <Col sm="8">
                  <Autocomplete
                    size="small"
                    disablePortal
                    id="combo-box-demo"
                    options={kategoriOption}
                    renderInput={(params) => (
                      <TextField
                        error={error && kategori.length === 0 && true}
                        size="small"
                        placeholder="SEMUA KATEGORI"
                        {...params}
                      />
                    )}
                    onInputChange={(e, value) => {
                      setKategori(value);
                      setPreviewPdf(false);
                    }}
                    defaultValue={kategori}
                  />
                </Col>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <Form.Group
                as={Row}
                className="mb-3"
                controlId="formPlaintextPassword"
              >
                <Form.Label column sm="4" style={textRight}>
                  Lebih Dari :
                </Form.Label>
                <Col sm="8">
                  <Form.Control
                    type="number"
                    value={lebihDari}
                    onChange={(e) => {
                      setLebihDari(e.target.value.toUpperCase());
                      setPreviewPdf(false);
                    }}
                  />
                </Col>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <Form.Group
                as={Row}
                className="mb-3"
                controlId="formPlaintextPassword"
              >
                <Form.Label column sm="4" style={textRight}>
                  Sampai Dengan :
                </Form.Label>
                <Col sm="8">
                  <Form.Control
                    type="number"
                    value={sampaiDengan}
                    onChange={(e) => {
                      setSampaiDengan(e.target.value.toUpperCase());
                      setPreviewPdf(false);
                    }}
                  />
                </Col>
              </Form.Group>
            </Col>
          </Row>
          <Button
            variant="contained"
            startIcon={<SearchIcon />}
            type="submit"
            style={{ marginTop: "20px" }}
          >
            LIHAT
          </Button>
        </Form>
      </Box>

      {previewPdf && (
        <div style={{ marginTop: "10px" }}>
          <ButtonGroup variant="outlined" color="secondary">
            <Button
              variant="outlined"
              startIcon={<PrintIcon />}
              onClick={generatePDF}
            >
              PDF
            </Button>
            <Button
              startIcon={<SearchIcon />}
              onClick={() => {
                setIsCetakExcel(true);
                setTimeout(() => {
                  onDownload();
                }, "1000");
              }}
            >
              Excel
            </Button>
          </ButtonGroup>
        </div>
      )}
      <div ref={reportTemplateRef} id="content" style={pdfContainer}>
        <div style={{ visibility: previewPdf === true ? "visible" : "hidden" }}>
          <p>
            {setting.namaPerusahaan} - {setting.alamatPerusahaan}
          </p>
          <p>({setting.kabupatenPerusahaan})</p>
          <p>{setting.kotaPerusahaan}</p>
          <p>NO. TELP. {setting.teleponPerusahaan}</p>
          <p>
            Dicetak Oleh: {user.username} | Tanggal:
            {` ${nowDate.getDate().toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}/${(nowDate.getMonth() + 1).toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}/${nowDate.getFullYear()} `}{" "}
            | Jam:{" "}
            {` ${nowDate.getHours().toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}:${(nowDate.getMinutes() + 1).toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}:${nowDate.getSeconds().toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })} `}
          </p>
          <h5 style={{ textAlign: "center", fontWeight: "700" }}>
            Laporan Pinjaman Jatuh Tempo
          </h5>
          <p>Cabang : {namaCabang}</p>
          <p>Marketing : {namaMarketing}</p>
          <p>Surveyor : {namaSurveyor}</p>
          <p>Kasir : {namaKasir}</p>
          <p>Kategori : {kategori}</p>
          <p>
            Per Tanggal :
            {` ${perTanggal.getDate().toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}/${(perTanggal.getMonth() + 1).toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}/${perTanggal.getFullYear()} `}
          </p>
          <p>Lebih Dari : {lebihDari}</p>
          <p>Sampai Dengan : {sampaiDengan}</p>
          <p></p>
          <table class="styled-table" ref={tableRef}>
            <thead style={{ backgroundColor: "gray", color: "white" }}>
              <tr>
                <th rowSpan="2" style={tableBorder}>
                  No
                </th>
                <th
                  rowSpan="2"
                  style={{ border: "1px solid black", width: "150px" }}
                >
                  Nama/No. Kontrak
                </th>
                <th
                  rowSpan="2"
                  style={{ border: "1px solid black", width: "150px" }}
                >
                  Alamat
                </th>
                <th
                  rowSpan="2"
                  style={{ border: "1px solid black", width: "100px" }}
                >
                  No. Telp
                </th>
                <th
                  rowSpan="2"
                  style={{ border: "1px solid black", width: "50px" }}
                >
                  Tanggal
                </th>
                <th rowSpan="2" style={tableBorder}>
                  JTO
                </th>
                <th
                  rowSpan="2"
                  style={{ border: "1px solid black", width: "80px" }}
                >
                  Jumlah Pinjaman
                </th>
                <th rowSpan="2" style={tableBorder}>
                  Tenor
                </th>
                <th colSpan="2" style={tableBorder}>
                  Keterlambatan
                </th>
                <th rowSpan="2" style={tableBorder}>
                  Angs. Ke
                </th>
                <th
                  rowSpan="2"
                  style={{ border: "1px solid black", width: "80px" }}
                >
                  Angsuran
                </th>
                <th
                  rowSpan="2"
                  style={{ border: "1px solid black", width: "80px" }}
                >
                  Saldo
                </th>
                <th
                  rowSpan="2"
                  style={{ border: "1px solid black", width: "150px" }}
                >
                  Agunan
                </th>
                <th rowSpan="2" style={tableBorder}>
                  Marketing
                </th>
                <th rowSpan="2" style={tableBorder}>
                  Surveyor
                </th>
              </tr>
              <tr>
                <th style={tableBorder}>Bulan</th>
                <th style={tableBorder}>Hari</th>
              </tr>
            </thead>
            <tbody>{list}</tbody>
          </table>
        </div>
      </div>
    </Container>
  );
};

export default LaporanPinjamanJatuhTempoFidusia;

const spacingTop = {
  mt: 4,
};

const pdfContainer = {
  padding: "20px",
  letterSpacing: "0.01px",
  fontSize: "12px",
  fontFamily: "sans-serif",
  width: "1200px",
};

const tableBorder = {
  border: "1px solid black",
};
